/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Pre_Purchase_DetailInputs */



/**
* | output |
* | --- |
* | "Independent condition surveys at the points where risk changes hands. A pre-purchase survey establishes a vessel's true condition before a sale; on-hire and ..." |
*
* @param {Service_Pre_Purchase_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_pre_purchase_detail = /** @type {((inputs?: Service_Pre_Purchase_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Pre_Purchase_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在风险转移的关键节点开展独立的状况检验。买船前检验在交易前确认船舶的真实状况；起租和退租检验在租期开始和结束时记录船舶状况及燃油存量，避免船东和租家日后产生纠纷。")
	return /** @type {LocalizedString} */ ("Independent condition surveys at the points where risk changes hands. A pre-purchase survey establishes a vessel's true condition before a sale; on-hire and off-hire surveys record condition and bunker quantities at the start and end of a charter, protecting owners and charterers from later disputes.")
});